// src/constants/tshirtSizes.ts
export const tshirtSizes: Record<string, string> = {
  yxs: "Youth XSmall",
  ys: "Youth Small",
  ym: "Youth Medium",
  yl: "Youth Large",
  yxl: "Youth XLarge",
  as: "Adult Small",
  am: "Adult Medium",
  al: "Adult Large",
  axl: "Adult XLarge",
  axxl: "Adult XXLarge",
  axxxl: "Adult XXXLarge",
};

export function getTshirtSizeOptions() {
  return Object.entries(tshirtSizes).map(([value, label]) => ({ value, label }));
}
